<div class="connected-privacy-policy-container-wrapper">
  <div class="connected-privacy-policy-container" *ngIf="text">
    <div class="connected-privacy-policy-body" [innerHtml]="text">
    </div>
  </div>
</div>